import { Checkbox } from "@centricsoftware/design-system";
import { SingleSelectWithOptionStore } from "csi/components/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useAttributeDefinitionStore } from "./AttributeDefinitionStore";

const AttributeDefinitionSectionUOM: FunctionComponent = observer(() => {
	const { 
		attrUOM,
		attrUOMEnabled,
		attrUOMError,
		attrUOMName,
		attrUOMType,
		attrUOMTypeError,
		attrUOMTypeName,
		isNew,
		isDouble,
		locale,
		onChangeUOM,
		onChangeUOMEnabled,
		onChangeUOMType,
		uomListDataStore,
		uomTypeListDataStore,
	} = useAttributeDefinitionStore();

	if (isDouble) {
		return;
	}

	const { 
		labelUOM,
		labelUOMEnabledRes,
		labelUOMType,
	 } = locale;

	return (
		<>
			{(isNew || attrUOMEnabled) && (
				<Checkbox
					ariaLabelRes={labelUOMEnabledRes}
					checked={attrUOMEnabled}
					labelRes={labelUOMEnabledRes}
					onChange={onChangeUOMEnabled}
					readOnly={!isNew}
				/>
			)}
			{attrUOMEnabled && (
				<>
					<SingleSelectWithOptionStore
						dataCsiAutomation="UOMType"
						disableClearable
						error={!!attrUOMTypeError}
						errorMessage={attrUOMTypeError}
						label={labelUOMType}
						onChange={onChangeUOMType}
						optionsStore={uomTypeListDataStore}
						readOnly={!isNew}
						required
						value={isNew ? attrUOMType : { id:attrUOMType, name: attrUOMTypeName }}
					/>
					<SingleSelectWithOptionStore
						dataCsiAutomation="UOM"
						disableClearable
						error={!!attrUOMError}
						errorMessage={attrUOMError}
						label={labelUOM}
						onChange={onChangeUOM}
						optionsStore={uomListDataStore}
						readOnly={!isNew}
						required
						value={isNew ? attrUOM : { id:attrUOM, name: attrUOMName }}
					/>
				</>
			)}
		</>
	);
});

export default AttributeDefinitionSectionUOM;